var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzleBattleIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 167,
    viewBox: "0 0 164 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.381 167C157.198 166.402 163.413 160.074 164 152.114L131.122 118.634L116.503 133.521L149.381 167ZM110.006 92.5823L89.3678 110.659L101.414 121.21L90.8409 131.976L97.6354 138.895L136.4 99.4214L129.605 92.5027L119.033 103.269L110.006 92.5823ZM75.6623 51.9256L34.9272 3.70238L0 0L3.63587 35.5661L52.9755 78.7829L75.6623 51.9256ZM0 152.114C0.587453 160.074 6.80152 166.402 14.6191 167L47.4969 133.521L32.8778 118.634L0 152.114Z",
    fill: "#6366B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9676 103.269L34.3951 92.5027L27.6006 99.4214L66.3651 138.895L73.1596 131.976L62.587 121.21L160.365 35.5661L164.001 0L129.073 3.70238L44.9676 103.269Z",
    fill: "#6366B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleBattleIconHome);
export default __webpack_public_path__ + "static/media/PuzzleBattleIcon-Home.e2fbef509de9e3be1fb803fd654be1e0.svg";
export { ForwardRef as ReactComponent };